import { get, filter, values, find } from 'lodash'
import { createSelector } from 'reselect'

const matchesStand = (object, standUuid) => !object.standUuid || object.standUuid === standUuid

// Customers
export const getCustomers = (state) => values(get(state, 'customer.byId', {}))

const getCustomer = (state, customerId) => get(state, `customer.byId.${customerId}`, {})

export const getCustomerRefId = (state, customerId) => {
  const customer = getCustomer(state, customerId)
  if (customer.externalRefId) {
    return [customer.externalRefId]
  }
  return null
}

export const makeGetCustomer = () => createSelector(
  [getCustomer],
  (customer) => customer
)

export const getActiveCustomerId = (state) => get(state, 'customer.activeCustomerId')

export const getActiveCustomer = createSelector(
  getCustomers, getActiveCustomerId,
  (customers, activeCustomerId) => {
    const customer = find(customers, ['uuid', activeCustomerId])

    return customer === undefined ? {} : customer
  }
)


// Customer Payments
const getAllPayments = (state) => values(get(state, 'customerPayment.byId', {}))

const getCustomerPayments = (state, customerId) => {
  const allPayments = getAllPayments(state)
  const customerPaymentIds = get(state, `customerPayment.byCustomerId.${customerId}`, [])
  const customerPayments = filter(allPayments, (payment) => customerPaymentIds.includes(payment.uuid))

  return customerPayments
}

export const makeGetCustomerPayments = () => createSelector(
  [getCustomerPayments],
  (payments) => payments
)


// Customer Ordering Preferences
export const getAllOrderingPreferences = (state) => values(get(state, 'orderingPreference.byId'))

const getCustomerOrderingPreferences = (state, customerId, revenueCenterId) => {
  const allPreferences = getAllOrderingPreferences(state)
  const customerPreferenceIds = get(state, `orderingPreference.byCustomerId.${customerId}`, [])
  const preferences = filter(allPreferences, (preference) => {
    return customerPreferenceIds.includes(preference.uuid) && matchesStand(preference, revenueCenterId)
  })

  return preferences
}

export const makeGetCustomerOrderingPreferences = () => createSelector(
  [getCustomerOrderingPreferences],
  (preferences) => preferences
)
